import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import GainfulButton from "Components/GainfulButton";
import { CSSTransition } from "react-transition-group";
import useReviewsData from "./hooks/useReviewsData";
import styles from "./styles.module.css";
import { ReviewItem } from "./components";
function ReviewsPage({ fullname, ready }) {
    const reviews = useReviewsData();
    const history = useHistory();
    const [review1, setReview1] = useState(null);
    const [review1show, setReview1show] = useState(false);
    useEffect(() => {
        if (reviews !== null) {
            setReview1(reviews.review_1);
            setTimeout(() => {
                setReview1show(true);
            }, 100);
        }
    }, [reviews]);
    const goNext = () => {
        history.push("/users/checkout/?from=quiz");
        window.location.reload();
    };
    const fname = fullname.split(" ")[0];
    return (_jsx("div", { className: styles.wrapper, children: _jsxs("div", { className: styles.page, children: [_jsxs("div", { className: styles.topblock, children: [_jsx("div", { className: styles.topname, children: ready ? (_jsx("span", { children: `${fname ? `${fname}, y` : "Y"}our results are ready` })) : (_jsx("span", { children: `${fname ? `${fname}, w` : "W"}e’re analyzing your answers...` })) }), _jsx("div", { className: styles.text, children: "Reviews from people like you.*" })] }), reviews && (_jsxs("div", { className: styles.reviewsblock, children: [_jsx("div", { className: review1show ? styles.show : styles.hide, children: review1 && _jsx(ReviewItem, { review: review1 }) }), _jsx("div", { className: styles.small_italic_text, children: "*Individual results may vary" })] })), _jsx(CSSTransition, { in: ready, timeout: 200, classNames: {
                        enterActive: styles.MyClassEnterActive,
                        enterDone: styles.MyClassEnterDone,
                        exitActive: styles.MyClassExit,
                        exitDone: styles.MyClassExitActive,
                    }, children: _jsx("div", { className: styles.bottomnav, children: _jsx(GainfulButton, { onClick: goNext, text: "View your results", disabled: !ready, width: "327px", extraClassName: styles.nextBtn, dataTracking: undefined, type: undefined, fiftyPercentWidth: undefined, dataAttr: undefined }) }) })] }) }));
}
export default ReviewsPage;
